import fetch from '../fetch';
import utils from '../../utils';

const transform = (data) => {
    
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + '',
            level: d.level,
            status: d.status,
            num : d.num
        };

        if(d.children) {
            current.children = transform(d.children);
            current.disabled = false
        }else{
            current.disabled = true
        }
        return current;
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return  fetch.get('zgcp/enter/getResultIdByTargetId/' + keywords.id)
    .then(response => {
        return response.payload;
    }).then(payload => {
        //无结果ID的情况下提示先保存基础信息
        if(payload.data.id == null){
            const result = [];
            result.unshift({id:-1,label:"基础信息",pid: 0,status: -1})
            const data = transform(utils.tree(result));
            return {
                data
            }
        }else{
            return fetch.post('zgcp/target/getAllTreeAndStatusByTarget', {
                targetId: keywords.id,
                id: payload.data.id
            })
            .then(payload => payload.payload.data)
            .then(result => {
                const first = result.filter(t => {return t.pid == '0'});
                if(first != null){
                    result.unshift({id:-1,label:"基础信息",pid:first[0].id,status: -1})
                    result.push({id:-2,label:"总浏览",pid:first[0].id,status: -1})
                }
                const data = transform(utils.tree(result));
                
                return {
                    data
                }
            })
        }
    }).then(resultData => {
        return resultData
    })
}

const querySearchAdd = (keywords = {pageNum: 1, pageSize: 100}) => {
    return  fetch.post('zgcp/enter/getResultIdByTargetIdAdd/' + keywords.id)
    .then(response => {
        return response.payload;
    }).then(payload => {
        //无结果ID的情况下提示先保存基础信息
        if(payload.data.id == null || keywords.type == 'onlyInsert'){
            const result = [];
            result.unshift({id:-1,label:"基础信息",pid: 0,status: -1})
            const data = transform(utils.tree(result));
            return {
                data
            }
        }else{
            return fetch.post('zgcp/target/getAllTreeAndStatusByTarget', {
                targetId: keywords.id,
                id: payload.data.id
            })
            .then(payload => payload.payload.data)
            .then(result => {
                const first = result.filter(t => {return t.pid == '0'});
                if(first != null){
                    result.unshift({id:-1,label:"基础信息",pid:first[0].id,status: -1})
                    result.push({id:-2,label:"总浏览",pid:first[0].id,status: -1})
                }
                const data = transform(utils.tree(result));
                
                return {
                    data
                }
            })
        }
    }).then(resultData => {
        return resultData
    })
}

const querySearchByUpdate = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('zgcp/target/getAllTreeAndStatusByTarget', {
        targetId: keywords.targetId,
        viewType: keywords.viewType,
        id: keywords.id
    })
    .then(response => response.payload.data)
    .then(result => {
        const first = result.filter(t => {return t.pid == '0'});
        if(first != null){
            result.unshift({id:-1,label:"基础信息",pid:first[0].id,status: -1})
            result.push({id:-2,label:"总浏览",pid:first[0].id,status: -1})
        }
        const data = transform(utils.tree(result));
        
        return {
            data
        }
    }).then(resultData => {
        return resultData
    })
}

const querySearchByAudit = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('zgcp/target/getAllTreeAndAuditByTarget', {
        targetId: keywords.targetId,
        viewType: keywords.viewType,
        id: keywords.id
    })
    .then(response => response.payload.data)
    .then(result => {
        const first = result.filter(t => {return t.pid == '0'});
        if(first != null){
            result.unshift({id:-1,label:"基础信息",pid:first[0].id,status: -1})
        }
        const data = transform(utils.tree(result));
        
        return {
            data
        }
    }).then(resultData => {
        return resultData
    })
}

const querySearchByReview = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('zgcp/target/getAllTreeAndReviewByTarget', {
        targetId: keywords.targetId,
        viewType: keywords.viewType,
        id: keywords.id
    })
    .then(response => response.payload.data)
    .then(result => {
        const first = result.filter(t => {return t.pid == '0'});
        if(first != null){
            result.unshift({id:-1,label:"基础信息",pid:first[0].id,status: -1})
        }
        const data = transform(utils.tree(result));
        
        return {
            data
        }
    }).then(resultData => {
        return resultData
    })
}

export default {
    querySearch,
    querySearchAdd,
    querySearchByUpdate,
    querySearchByReview,
    querySearchByAudit
}